import { ReactComponent as Icon20Stars } from 'img/quota-landing/aiTariff/stars_20.svg';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    fakedoorSummarization,
    fakedoorSummarizationClickCount,
    fakedoorSummarizationExts,
} from 'reactApp/appHelpers/featuresHelpers/features/summarization';
import { sendDwhButton } from 'reactApp/modules/dwh/dwh.helpers';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { getDataFromStorage, saveDataToStorage } from 'reactApp/storage';
import { MenuButton } from 'reactApp/ui/ReactViewer/ViewerMenu/MenuButton/MenuButton';

interface Props {
    ext?: string;
    count: number;
}

const name = 'mnz_fake_summarize';
const fakedoorStorageKey = 'fake-summarize';

export const SummarizeMenuButton = memo<Props>(({ ext = '', count }) => {
    const dispatch = useDispatch();
    const [hide, setHide] = useState(false);

    const onSummarize = useCallback(() => {
        sendDwhButton({ action: 'click', name, data: { file_ext: ext } });

        dispatch(
            showSnackbarAction({
                id: 'fake-summarize-click',
                text: 'Этой функции пока нет. Теперь знаем, что нужна, благодаря вам',
                type: SnackbarTypes.success,
                closable: true,
            })
        );

        saveDataToStorage(fakedoorStorageKey, { counts: { close: count + 1 } });

        setHide(true);
    }, [count, dispatch, ext]);

    useEffect(() => {
        sendDwhButton({ name, data: { file_ext: ext } });
    }, [ext]);

    if (hide) {
        return null;
    }

    return <MenuButton text="Краткий пересказ" icon={<Icon20Stars />} onClick={onSummarize} qaId="summarize" gradient />;
});

SummarizeMenuButton.displayName = 'SummarizeMenuButton';

export const useSummarizeMenuButton = (ext = '') => {
    if (!fakedoorSummarization || !fakedoorSummarizationExts.includes(ext)) {
        return null;
    }

    const data = getDataFromStorage(fakedoorStorageKey);
    const count = data?.counts?.close || 0;

    if (count >= fakedoorSummarizationClickCount) {
        return null;
    }

    return <SummarizeMenuButton ext={ext} count={count} />;
};
